import React, { useState } from 'react';
import Sidebar from './Sidebar';
import HeaderJvweb from './HeaderJvweb';
import './LayoutJvweb.css';

const LayoutJvweb = ({ children }) => {
    const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(true);

    return (
        <div className={`layout-jvweb ${isSidebarCollapsed ? 'layout-sidebar-collapsed' : ''}`}>
            <Sidebar onToggle={setIsSidebarCollapsed} />
            <div className="layout-jvweb-main">
                <HeaderJvweb />
                <main className="layout-jvweb-content">
                    {children}
                </main>
            </div>
        </div>
    );
};

export default LayoutJvweb;
